import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('userLanguage') || 'en';
console.log(
    '🌐 [i18n-backend.ts] Initial language from localStorage:',
    savedLanguage,
    'localStorage value:',
    localStorage.getItem('userLanguage')
);

// Lazy load translations
const loadLocales = (language: string, namespace: string) => {
    return import(
        /* webpackChunkName: "locale-[request]" */
        `./assets/locales/${language}/${namespace}.json`
    );
};

i18n.use(initReactI18next)
    .use(
        resourcesToBackend((language: string, namespace: string) => {
            return loadLocales(language, namespace);
        })
    )
    .init({
        lng: savedLanguage, // Set initial language from localStorage
        fallbackLng: 'en',
        load: 'languageOnly',
        ns: ['translation'],
        defaultNS: 'translation',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        }
    });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng: string) => {
    console.log('🌐 [i18n-backend.ts] Language changed to:', lng);
    console.trace('🌐 Change triggered by:'); // Show stack trace
    localStorage.setItem('userLanguage', lng);
});

export default i18n;
